import type {PackageOwnership, PackageStatus, PackageType} from '@sollapay/enums';

export interface ClarificationRequest {
  name: string;
  reason: string;
}

/** The `name` of a clarification request that covers the whole package rather than one field. */
export const PACKAGE_CLARIFICATION_FIELD = 'package';

/** The `name` of the clarification raised when a seller change voids the signed supplementary declaration. */
export const SUPPLEMENTARY_REVOKED_CLARIFICATION_FIELD = 'supplementary_declaration_revoked';

export type ActivationPackageDTO = {
  id: string;
  type: PackageType;
  status: PackageStatus;
  ownership: PackageOwnership;
  readiness: PackageReadiness;
  canEdit: boolean;
  canSubmit: boolean;
  clarificationRequests: ClarificationRequest[] | null;
  clarificationRound: number;
  clarificationRequestedAt: string | null;
  clarificationRequestedBy: string | null;
};

export type PackageMissingItem = {
  code: string;
  message: string;
  field?: string;
  documentType?: string;
};

export type PackageReadiness = {
  isReady: boolean;
  totalCount: number;
  missingCount: number;
  missing: PackageMissingItem[];
};

// POST /trust-accounts/:id/packages/:packageType/submit

export type SubmitPackageDTO = {
  package: {
    id: string;
    type: PackageType;
    status: PackageStatus;
  };
};
